export default __webpack_public_path__ + "static/media/Product-Id.46d81494.jpg";